import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUrlParams } from "hooks/useUrlParams";
import { useTheme } from "@emotion/react";

export default function HowToUseSlider() {
  const { contentWork } = useUrlParams();
  const { t } = useTranslation(["common", contentWork]);
  const howToUseItems = t(`${contentWork}:HowToUseItems`, { returnObjects: true });

  const theme = useTheme();

  return (
    <Box sx={{ width: "100%", maxWidth: 420 }}>
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        style={{
          "--swiper-pagination-bullet-inactive-opacity": "1",
          "--swiper-pagination-bullet-size": "6px",
          "--swiper-pagination-bullet-horizontal-gap": "2px",
          "--swiper-pagination-color":
            theme.components.howToUseSlider.bullet.active, // アクティブ
          "--swiper-pagination-bullet-inactive-color":
            theme.components.howToUseSlider.bullet.inactive, // 非アクティブ
        }}
      >
        {/* howToItems.map((item, index) => (*/}
        {howToUseItems.map((item, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={(theme) => ({
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 2,
                padding: 3,
                textAlign: "center",
                minHeight: "350px",
                ...theme.components.howToUseSlider.paper,
              })}
            >
              <Typography
                sx={(theme) => ({
                  fontSize: contentWork === "higurashi" ? "14px" : "16px",
                  fontWeight: "bold",
                  fontFamily: theme.typography.fontFamily.heading,
                })}
              >
                {item.point}
              </Typography>

              <Box
                sx={{
                  width: "100%",
                }}
              >
                <Typography
                  sx={(theme) => ({
                    marginY: 2,
                    whiteSpace: "pre-line",
                    lineHeight: 2.0,
                    ...theme.components.howToUseSlider.text.title,
                  })}
                >
                  {item.title}
                </Typography>
              </Box>

              {item.icon}

              <Box
                sx={(theme) => ({
                  width: "90%",
                  paddingY: 3,
                  marginY: 2,
                  ...theme.components.howToUseSlider.overlay,
                })}
              >
                <Typography
                  sx={(theme) => ({
                    whiteSpace: "pre-line",
                    lineHeight: 1.8,
                    ...theme.components.howToUseSlider.text.description,
                  })}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
